export default function () {
  this.doLoad()
}



// WEBPACK FOOTER //
// ./src/app/tenant/profile/me/components/overview/components/feed/resources/mounted.js